import axios from 'axios';
import queryString from '../utils/HttpUtils';
import AbstractClassInstantiationException from '../exceptions/AbstractClassInstantiationException';

/**
 * Szülő osztály minden szervíz osztály számára, becsomagolja az Axios http funckióit
 */
export default class Service {
    /**
     * Nem példányosítható, az öröklő osztálynak kell egy super(baseUrl)-t hívni
     * @param baseUrl
     */
    constructor(baseUrl) {
        this.baseUrl = baseUrl;

        if (this.constructor === Service) {
            throw new AbstractClassInstantiationException();
        }
    }

    /**
     *
     * @returns {string} a szervíz elérési újának az alapja
     */
    getBaseUrl() {
        return this.baseUrl;
    }

    /**
     *
     * @param {string} url Service elérési útja
     * @param {object} params GET paraméterek
     * @param bodyParams
     * @returns {AxiosPromise<any>}
     */
    get(url, params, bodyParams) {
        // console.log("GET: " + this.getBaseUrl() + url + queryString(params));
        return axios.get(this.getBaseUrl() + url + queryString(params), { data: bodyParams });
    }

    getWithHeaders(url, headers) {
        return axios.get(this.getBaseUrl() + url, {headers});
    }

    /**
     *
     * @param {string} url Service elérési útja
     * @param {object} params POST paramétere
     * @returns {AxiosPromise<any>}
     */
    post(url, params) {
        // console.log('axios post hívás')
        return axios.post(this.getBaseUrl() + url, params);
    }

    postWithHeaders(url, params, headers) {
        return axios.post(this.getBaseUrl() + url, params, {headers});
    }

    patch(url, params) {
        // console.log('axios post hívás')
        return axios.patch(this.getBaseUrl() + url, params);
    }

    postFormData(url, params) {
        let queryStringLocal = '';
        Object.keys(params).forEach((key) => {
            queryStringLocal += key;
            queryStringLocal += '=';
            queryStringLocal += params[key];
            queryStringLocal += '&';
        });
        if (queryStringLocal.length > 0) {
            queryStringLocal = queryStringLocal.substr(0, queryStringLocal.length - 1);
        }

        return axios({
            method: 'post',
            url: this.getBaseUrl() + url,
            data: queryStringLocal,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        });
    }

    /**
     *
     * @param {string} url
     * @param {object} params
     * @returns {AxiosPromise}
     */
    head(url, params) {
        return axios.head(this.getBaseUrl() + url + queryString(params));
    }

    /**
     *
     * @param {string} url
     * @param {object} params
     */
    open(url, params) {
        window.open(this.getBaseUrl() + url + queryString(params));
    }
}
